/* eslint-disable react/prop-types */
// Flow types automatically removed

import DisplayPromoCodeWrapper from './DisplayPromoCodeWrapper';
import { graphql, QueryRenderer } from 'react-relay/legacy';
import getter from 'dibs-object-getter';
import * as tracking from 'dibs-tracking';
import { getBuyerId } from 'dibs-cookie-jar';
import { localStorage } from 'dibs-browser-storage';

const getGeoLocationPromoGroupFromLocalStorage = () => {
    let geoLocationPromos = [];

    for (const [key, value] of Object.entries({ ...localStorage })) {
        if (key.includes('geoLocationPromoGroup:')) {
            geoLocationPromos = [
                ...geoLocationPromos,
                {
                    key,
                    value,
                },
            ];
        }
    }

    return geoLocationPromos;
};

const trackGeoLocationPromos = props => {
    let geoLocationPromos = getGeoLocationPromoGroupFromLocalStorage();

    if (!geoLocationPromos?.length) {
        props?.viewer?.promotionVariantControl?.forEach(({ promotionId, promoGroup }) => {
            if (promoGroup) {
                localStorage.setItem(`geoLocationPromoGroup:${promotionId}`, promoGroup);
                geoLocationPromos = [
                    ...geoLocationPromos,
                    {
                        promoGroup,
                    },
                ];
            }
        });
    }

    geoLocationPromos?.forEach(promoGroup => {
        const promoGroupValue = promoGroup?.value || '';
        tracking.trackEvent({
            category: 'a/b testing',
            action: 'decor_fashion_free_ship',
            label: promoGroupValue,
            geoTest1: `${
                promoGroupValue ? `DECOR_FASHION_FREE_SHIP - ${promoGroupValue.toUpperCase()}` : ''
            }`,
        });
    });
};

const renderComponent = ({ props }) => {
    trackGeoLocationPromos(props);
    const viewer = getter(props).value('viewer');
    return <DisplayPromoCodeWrapper viewer={viewer} {...props} />;
};

const DisplayPromoCodeRenderer = props => {
    const { itemId, environment } = props;

    // we want to use the masquerade buyer ID when available
    const userId = getBuyerId(document.cookie);
    return (
        <QueryRenderer
            environment={environment}
            query={graphql`
                query DisplayPromoCodeRenderer_Query(
                    $userId: String = ""
                    $itemId: String = ""
                    $optionalItemId: String
                    $hasUserId: Boolean!
                    $hasItemId: Boolean!
                    $isGeoLocationPromoGroupSet: Boolean!
                ) {
                    viewer {
                        ...DisplayPromoCodeWrapper_viewer
                        promotionVariantControl(userId: $userId, listTypes: ["ABTEST_PROMOTIONS"])
                            @skip(if: $isGeoLocationPromoGroupSet) {
                            promoGroup
                            promotionId
                        }
                    }
                }
            `}
            variables={{
                userId,
                itemId,
                optionalItemId: itemId,
                hasUserId: !!userId,
                hasItemId: !!itemId,
                isGeoLocationPromoGroupSet: !!getGeoLocationPromoGroupFromLocalStorage().length,
            }}
            render={({ error, props: rendererProps }) => {
                if (error) {
                    return null;
                } else if (rendererProps) {
                    return renderComponent({
                        props: { ...rendererProps, ...props },
                    });
                }

                return null;
            }}
        />
    );
};

export default DisplayPromoCodeRenderer;
